module.exports = __webpack_public_path__ + "img/csob.ea4cb359.svg";